<template>
  <div>
    <layout-panel :show-header="false">
      <el-menu :default-active="$route.path+'?userid='+userid"
               class="el-menu-demo"
               mode="horizontal"
               router>
        <el-menu-item :index="'/users/detail/info?userid='+userid">基础信息</el-menu-item>
        <el-menu-item router="true"
                      :index="'/users/detail/service?userid='+userid">沟通记录
        </el-menu-item>
        <el-menu-item :index="'/users/detail/account?userid='+userid">账户信息</el-menu-item>
        <el-menu-item :index="'/users/detail/device?userid='+userid">设备信息</el-menu-item>
        <el-menu-item :index="'/users/detail/operate?userid='+userid">运营信息</el-menu-item>
        <el-menu-item :index="'/users/detail/log?userid='+userid">管理日志</el-menu-item>
        <el-menu-item :index="'/users/detail/workinfo-log?userid='+userid">职业信息修改记录</el-menu-item>
      </el-menu>
      <Br/>
      <Br/>
      <router-view></router-view>
    </layout-panel>

  </div>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      userid: this.$route.query.userid || 0,
    }
  },
  computed: Vuex.mapState({
    userOptions: state => state.users.userOptions,
  }),
  watch: {},
  created () {
    if (this.userOptions.length <= 0) {
      this.$store.dispatch('getUserRelatedOptions')
    }
  },
  methods: {
    ...Vuex.mapActions([]),
  },
}
</script>
<style lang="scss"
       scoped></style>



// WEBPACK FOOTER //
// src/views/users/pages/detail/Index.vue